<script setup>
import { appConfig } from '../../utils/config'
</script>

<template>
  <footer class="site-footer">
    <RouterLink class="site-footer__brand" to="/" aria-label="CIPOPO 首页">
      <img class="site-footer__logo" src="/cipopo_logo.png" alt="CIPOPO" />
    </RouterLink>

    <div class="site-footer__meta">
      <nav class="site-footer__links" aria-label="页脚链接">
        <RouterLink class="site-footer__link" to="/privacy">隐私政策</RouterLink>
        <span class="site-footer__divider" aria-hidden="true">·</span>
        <RouterLink class="site-footer__link" to="/manual">使用说明</RouterLink>
      </nav>
      <p class="site-footer__copyright">© 2026 CIPOPO. 保留所有权利</p>
      <p v-if="appConfig.icpRecord" class="site-footer__icp">
        <a
          :href="appConfig.icpRecordUrl"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="`${appConfig.icpRecord}（在新窗口打开）`"
        >
          {{ appConfig.icpRecord }}
        </a>
      </p>
    </div>
  </footer>
</template>

<style scoped>
.site-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 72px;
  padding: 16px clamp(20px, 5vw, 48px);
  background: #000000;
}

.site-footer__brand {
  display: inline-flex;
  flex-shrink: 0;
}

.site-footer__logo {
  display: block;
  height: 28px;
  width: auto;
}

.site-footer__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.site-footer__links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.site-footer__link {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  line-height: 1.4;
  transition: color 0.2s ease;
}

.site-footer__link:hover {
  color: #ffffff;
}

.site-footer__divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
  line-height: 1;
}

.site-footer__copyright,
.site-footer__icp {
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  line-height: 1.4;
  text-align: right;
}

.site-footer__icp a {
  color: rgba(255, 255, 255, 0.72);
  transition: color 0.2s ease;
}

.site-footer__icp a:hover {
  color: #ffffff;
}

@media (max-width: 640px) {
  .site-footer {
    flex-direction: column;
    align-items: flex-start;
    min-height: auto;
    padding: 20px 16px 24px;
  }

  .site-footer__logo {
    height: 24px;
  }

  .site-footer__meta {
    align-items: flex-start;
  }

  .site-footer__copyright,
  .site-footer__icp {
    text-align: left;
  }
}
</style>
